module.exports = __webpack_public_path__ + "896fdc96a9ba84a88357fd2625b71e8f.jpg";